import React, { useContext, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import ErrorBoundary from "../components/ErrorBoundary";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import TopBar from "../components/TopBar";

export default function DashboardLayout() {
  const { menuPosition } = useContext(AuthContext);
  const [menuMovilAbierto, setMenuMovilAbierto] = useState(false);
  const { pathname } = useLocation();

  // Si una página falla, el menú y la barra superior siguen visibles y al
  // cambiar de ruta se vuelve a intentar.
  const pagina = (
    <ErrorBoundary titulo="esta página" resetKey={pathname}>
      <Outlet />
    </ErrorBoundary>
  );

  if (menuPosition === "superior") {
    return (
      <div className="h-screen flex flex-col overflow-hidden">
        <Navbar />
        <div className="flex-1 overflow-y-auto p-4 sm:p-6 bg-slate-50">
          {/* Aquí se renderizan las páginas hijas */}
          {pagina}
        </div>
      </div>
    );
  }

  // Por default: menú lateral
  return (
    <div className="h-screen flex overflow-hidden">
      <Sidebar abiertoMovil={menuMovilAbierto} onCerrarMovil={() => setMenuMovilAbierto(false)} />
      <div className="flex-1 flex flex-col min-w-0 h-screen overflow-hidden">
        <TopBar onAbrirMenu={() => setMenuMovilAbierto(true)} />
        <div className="flex-1 overflow-y-auto p-4 sm:p-6 bg-slate-50">
          {/* Aquí se renderizan las páginas hijas */}
          {pagina}
        </div>
      </div>
    </div>
  );
}
